import 'zone.js';
import { registerLocaleData } from '@angular/common';
import localeEnIn from '@angular/common/locales/en-IN';
import { bootstrapApplication } from '@angular/platform-browser';

registerLocaleData(localeEnIn);
import { setAssetPath } from '@ionic/core/components';
import { appConfig } from './app/app.config';
import { App } from './app/app';

// Ensure Ionic/Stencil has a valid base URL for icon assets (avoids "Invalid base URL" error)
const baseUrl = typeof window !== 'undefined' && window.location?.origin
  ? window.location.origin + '/'
  : '/';
setAssetPath(baseUrl);

bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));
